<template>
  <v-container fluid>
    <EmployeePathToReadinessView
      v-if="!isNewDesign && isValidEmployee"
      @employeeStatusChanged="handleEmployeeStatusChanged"
    />
    <NewEmployeePathToReadinessView
      v-else-if="isValidEmployee"
      @employeeStatusChanged="handleEmployeeStatusChanged"
    />
  </v-container>
</template>

<script>
import EmployeePathToReadinessView from "@/views/DetailEmployeeViews/EmployeePathToReadinessView.vue";
import NewEmployeePathToReadinessView from "@/views/DetailEmployeeViews/NewEmployeePathToReadinessView.vue";
import { useEmployeeStore } from "@/store/pinia/employee";

export default {
  name: "EmployeePathToRedinessGateway",
  components: {
    EmployeePathToReadinessView,
    NewEmployeePathToReadinessView,
  },
  data() {
    return {
      isValidEmployee: false,
      isValidating: false,
    };
  },
  computed: {
    isNewDesign() {
      return this.flags["employee.page_horizontal_menu.enabled"] || false;
    },
  },
  watch: {
    isNewDesign: {
      handler() {
        this.$store.dispatch("featureFlags/checkFeatureFlags", this.$route);
      },
      immediate: true,
    },
    "$route.params.id": {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.validateEmployee();
        }
      },
      immediate: false,
    },
  },
  async mounted() {
    await this.$watchFlag("employee.page_horizontal_menu.enabled", false);
    await this.$store.dispatch("featureFlags/checkFeatureFlags", this.$route);
    await this.validateEmployee();
  },
  methods: {
    async validateEmployee() {
      const empId = this.$route.params.id;
      if (!empId) {
        this.redirectTo404();
        return;
      }

      // Prevent concurrent validation calls
      if (this.isValidating) {
        return;
      }

      this.isValidating = true;

      try {
        const employeeStore = useEmployeeStore();
        const accountId = JSON.parse(localStorage.getItem("currentAccountID"));

        if (!accountId) {
          this.redirectTo404();
          this.isValidating = false;
          return;
        }

        // Check if employee is already loaded in store to avoid duplicate API call
        const existingEmployee = employeeStore.currentEmployee;
        if (existingEmployee && existingEmployee.id == empId) {
          // Employee already loaded, just mark as valid
          this.isValidEmployee = true;
          this.isValidating = false;
          return;
        }

        // Try to fetch the employee (don't force refresh if already in store)
        const employeeData = await employeeStore.fetchCurrentEmployee(empId, false);

        if (!employeeData || !employeeData.id) {
          this.redirectTo404();
          this.isValidating = false;
          return;
        }

        // Employee is valid
        this.isValidEmployee = true;
      } catch (error) {
        console.error("Error validating employee:", error);
        this.redirectTo404();
      } finally {
        this.isValidating = false;
      }
    },
    redirectTo404() {
      this.$router.replace({ name: "NotFound" });
    },
    handleEmployeeStatusChanged() {
      this.$emit("employeeStatusChanged");
    },
  },
};
</script>
